import Program from "wwg-utilities/dist/collections/program";
import Provider from "wwg-utilities/dist/collections/provider";
import gaDataLayerEvent from "../../../lib/hooks/GA/gaDataLayerEvent";
import ReadMore from "../ReadMore";
import RenderRichText from "../RenderRichText";
import Requirements from "../Requirements";

interface AdmissionsProps {
    program: Program;
}

const Admissions: React.FC<AdmissionsProps> = ({ program }) => {
    return (
        <>
            <hr className="mx-4 my-10" />

            <h3 className="text-2xl font-bold text-primary-dark">
                Admissions
            </h3>
            <section className="mx-4 lg:mx-auto">
                <Requirements program={program} />
            </section>
            {Boolean(
                program.admissionRequirements?.requirementsComment &&
                program.admissionRequirements.requirementsComment.length >=
                300,
            ) && (
                    <div
                        onClick={() => {
                            gaDataLayerEvent({
                                event: 'tab_click',
                                clicked_tab: {
                                    program_name: `${program.name} at ${(program.institution as Provider).name
                                        }`,
                                    title: 'read more',
                                    value: 'admission section',
                                },
                            });
                        }}
                    >
                        <ReadMore>
                            <div className="font-light text-paragraph">
                                <RenderRichText
                                    html={
                                        program.admissionRequirements?.requirementsComment ||
                                        ''
                                    }
                                ></RenderRichText>
                            </div>
                        </ReadMore>
                    </div>
                )}
            {Boolean(
                program.admissionRequirements?.requirementsComment &&
                program.admissionRequirements.requirementsComment.length <
                300,
            ) && (
                    <section className="font-light text-paragraph">
                        <RenderRichText
                            html={
                                program.admissionRequirements?.requirementsComment || ''
                            }
                        ></RenderRichText>
                    </section>
                )}
        </>
    );
};

export default Admissions;